export default { 
    'PPTshare.Title':'该演讲未开启公开访问',
    'PPTshare.Tips':'如您拥有该播放文档的访问权限，请登录后查看',
    'PPTshare.btn':'开始使用',
}